import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EnterpriseComponent } from './enterprise/enterprise.component';
import { ParamsVendasComponent } from './params-vendas/params-vendas.component';
import { MotNaoCompraComponent } from './mot-nao-compra/mot-nao-compra.component';
import { PlanosComponent } from './planos/planos.component';
import { PlanoDetailsComponent } from './planos/plano-details/plano-details.component';

const settingsRoutes: Routes = [
  { path: 'enterprise/:cnpj', component: EnterpriseComponent },
  { path: 'paramsvendas/:cnpj', component: ParamsVendasComponent },
  { path: 'motnaocompra/:cnpj', component: MotNaoCompraComponent },
  { path: 'planos/:cnpj', component: PlanosComponent },
  { path: 'planos/:cnpj/:id', component: PlanoDetailsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(settingsRoutes)],
  exports: [RouterModule],
})
export class SettingsRoutingModule {}
